import * as React from 'react';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

import { EmphasizedTextRed, Text } from '../style.css';
import { LogoImg } from '../../Logo';
import { api } from '../../../helpers/routes';
import Button from '../../UI/Button';
import Input from '../../UI/Input/Input';
import { isValidEmail } from '../../../helpers/validation';
import VerticalSpacer from '../../UI/VerticalSpacer';

/* Helpers */
const validationFailedMsg = 'Please enter a valid email address.';

/* Components */
class SubscriptionForm extends React.Component<{ onSubmitSuccess: () => void }, { validationFailed: boolean }> {
  private readonly emailFieldRef = React.createRef<HTMLInputElement>();

  constructor(props) {
    super(props);
    this.state = { validationFailed: false };
  }

  componentDidMount(): void {
    this.emailFieldRef.current.addEventListener('invalid', () => {
      this.setState({ validationFailed: true });
    });
  }

  handleChange = () => {
    this.setState({ validationFailed: false });
  };

  handleSubmit = e => {
    const { onSubmitSuccess } = this.props;

    if (e) {
      e.preventDefault();
    }

    const emailField = this.emailFieldRef.current;

    if (!emailField || !isValidEmail(emailField.value)) {
      this.setState({ validationFailed: true });
      return;
    }

    emailField &&
      axios
        .post(api.newsletterSignup, { email: emailField.value })
        .then(onSubmitSuccess)
        .catch(error => Sentry.captureException(error));
  };

  render() {
    const { validationFailed } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <div style={{ margin: 'auto', maxWidth: '95%', width: '340px' }}>
          <Input
            ref={this.emailFieldRef}
            autofocus
            errorText={validationFailed ? validationFailedMsg : null}
            handleChange={this.handleChange}
            hasError={validationFailed}
            height="46px"
            justifyContent="center"
            name="email"
            placeholder="Email"
            required
            width="100%"
          />
        </div>
        <Button maxWidth="95%" type="submit" width="340px">
          SUBSCRIBE NOW
        </Button>
      </form>
    );
  }
}

const SignUpView: React.ComponentType<{ onSubmitSuccess: () => void; s3BasePath: string }> = ({
  onSubmitSuccess,
  s3BasePath,
}: {
  onSubmitSuccess: () => void;
  s3BasePath: string;
}) => (
  <>
    <VerticalSpacer mobileHeight="10px" />
    <LogoImg height="35px" margin="24px 0 0 0" s3BasePath={s3BasePath} width="90px" />
    <Text>
      Subscribe now to <EmphasizedTextRed>save up to 30%</EmphasizedTextRed> on your favorite luxury items!
    </Text>
    <SubscriptionForm onSubmitSuccess={onSubmitSuccess} />
  </>
);

export default SignUpView;
